
// import InlineSVG from 'svg-inline-react';


const Icon = ({ name, customClass}) => {


  const chooseSvg = () => {

    let svgPath = <svg></svg>

    switch(name){

      case 'arrow-left2':
        svgPath = `<svg viewBox="0 0 32 32" id="icon-${name}" fill="none" class="icon ${customClass}"><path d="M12.586 27.414l-10-10c-0.781-0.781-0.781-2.047 0-2.828l10-10c0.781-0.781 2.047-0.781 2.828 0s0.781 2.047 0 2.828l-6.586 6.586h19.172c1.105 0 2 0.895 2 2s-0.895 2-2 2h-19.172l6.586 6.586c0.39 0.39 0.586 0.902 0.586 1.414s-0.195 1.024-0.586 1.414c-0.781 0.781-2.047 0.781-2.828 0z"></path></svg>`
        break;
      case 'checkbox-unchecked':
        svgPath = `<svg viewBox="0 0 24 24" id="icon-${name}" fill="none" class="icon ${customClass}"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm14 16V5H5v14h14z"/></svg>`
        break;
      case 'checkbox-checked':
        svgPath = `<svg viewBox="0 0 24 24" id="icon-${name}" fill="none" class="icon ${customClass}"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 9l5 5 9-9-1.41-1.42L10 14.17l-3.59-3.58L5 12z"/></svg>`
        break;
      case 'chevron-right':
        svgPath = `<svg viewBox="0 0 24 24" id="icon-${name}" fill="none" class="icon ${customClass}"><path d="M9 6.71a.996.996 0 0 0 0 1.41L12.88 12 9 15.88a.996.996 0 1 0 1.41 1.41L15 12.7a.996.996 0 0 0 0-1.41L10.41 6.7c-.38-.38-1.02-.38-1.41.01z"/></svg>`
        break;
      case 'chevron-left':
        svgPath = `<svg viewBox="0 0 24 24" id="icon-${name}" fill="none" class="icon ${customClass}"><path d="M15 6.705a.996.996 0 0 0-1.41 0L9 11.295a.996.996 0 0 0 0 1.41l4.59 4.59a.996.996 0 1 0 1.41-1.41l-3.88-3.89L15 8.115c.39-.39.38-1.03 0-1.41z" /></svg>`
        break;
      case 'chevron-down':
        svgPath = `<svg viewBox="0 0 24 24" id="icon-${name}" fill="none" class="icon ${customClass}"><path d="M15.875 9l-3.88 3.88L8.115 9a.996.996 0 1 0-1.41 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.39-1.42 0z"/></svg>`
        break;
      case 'chevron-up':
        svgPath = `<svg viewBox="0 0 24 24" id="icon-${name}" fill="none" class="icon ${customClass}"><path d="M11.295 9l-4.59 4.59A.996.996 0 1 0 8.115 15l3.89-3.88 3.88 3.88a.996.996 0 1 0 1.41-1.41L12.705 9a.996.996 0 0 0-1.41 0z"/></svg>`
        break;
    default:
        svgPath = `<svg viewBox="0 0 32 32" id="icon-${name}" fill="none" class="icon ${customClass}"></svg>`


    }

    return svgPath
  }
  
  return (

    // <InlineSVG src={chooseSvg()} />
    <div></div>
  );
};

const page = Icon;
export  { page as Icon };
